import { 
    GetAllBiomarkersByPatientIdPath, 
    GetFavoriteBiomarkersByPatientIdPath, 
    GetApi 
} from "../../apis/Api";

async function GetAllBiomarkersByPatientId(patient_id, isWholeList = false){

    const biomarkers = await GetApi(isWholeList ? GetAllBiomarkersByPatientIdPath(patient_id) : GetFavoriteBiomarkersByPatientIdPath(patient_id))
        .then(response => response.json())
        .then(data => {
            if (data.result)
                return convert(data.result, isWholeList)
        });
        
    return biomarkers;
}

function convert(element, isWholeList){
    return {
        patient_name: element.patient_name,
        patient_id: element.patient_id,
        patient_ehr: element.patient_ehr,
        feedings: element.feedings.map((feeding) => {
            return {
                timestamp: feeding.timestamp,
                weight: feeding.weight,
                weight_uom: feeding.weight_uom,
                volume: feeding.volume,
                volume_uom: feeding.volume_uom,
                consumption: feeding.consumption,
                consumption_uom: feeding.consumption_uom,
                biomarkers: feeding.biomarkers.map((biomarker) =>{
                    return {
                        name: biomarker.biomarker_name,
                        id: biomarker.biomarker_id,
                        value: isWholeList ? biomarker.biomarker_value : Math.round(biomarker.biomarker_value * 100) / 100,
                        abv: biomarker.biomarker_abv,
                        sort_index: biomarker.biomarker_sort_index,
                    };
                }).sort((a,b) => a.sort_index - b.sort_index)
            };
        })
    };
}

export default GetAllBiomarkersByPatientId;